<template>
	<Tooltip placement="bottom" :overlayStyle="{ 'max-width': 'min-content' }">
		<template #title v-if="maxCount != null">
			<NoLineBreaks>{{ $t('base-stations.baseStationsCountLimitMessage') }}</NoLineBreaks>
			<NoLineBreaks>{{ $t('base-stations.baseStationsMaxCount') }} {{ maxCount }}</NoLineBreaks>
			<NoLineBreaks>{{ $t('base-stations.baseStationsWorkingCount') }} {{ workingCount }}</NoLineBreaks>
		</template>
		<slot></slot>
	</Tooltip>
</template>

<script>
import { Tooltip } from 'ant-design-vue';

import NoLineBreaks from '@/components/common/NoLineBreaks';

export default {
	components: {
		Tooltip, NoLineBreaks,
	},
	props: ['workingCount', 'maxCount'],
}
</script>
